import { createSelector } from 'reselect';

const selectUpdateSocialLinksState = state => state.UpdateSocialLinks;

export const selectIsUpdatinSocialLinks = createSelector(
  selectUpdateSocialLinksState,
  (state, props) => state.updatingSocialLinks
);



// WEBPACK FOOTER //
// ./src/store/graphql/UpdateSocialLinks/selectors.js